import React, { useMemo } from "react";
import { ReportFilters } from "@common/types/filters/reports";
import { useEntities } from "@hooks/useEntities";
import { useCashFlowQuery } from "@api/cashFlow.api";
import { ChildrenProps } from "../../types";
import { CashFlowContext } from "./cash-flow.context";

interface Props extends ChildrenProps {
    filters: ReportFilters;
}

export const CashFlowContextProvider: React.FC<Props> = ({
    filters,
    children,
}) => {
    const entities = useEntities();

    const filtersToPass = {
        ...filters,
        entityIds:
            filters.entityIds && filters.entityIds.length > 0
                ? filters.entityIds
                : entities.map((entity) => entity.id),
    };

    const { data, isLoading: isCashFlowReportLoading } = useCashFlowQuery({
        filters: filtersToPass,
    });

    const value = useMemo(
        () => ({
            cashFlowReport: data?.report,
            cashFlowFiltersUsed: data?.filtersUsed,
            reportCreatedAt: data?.reportCreatedAt,
            isCashFlowReportLoading,
        }),
        [data, isCashFlowReportLoading],
    );

    return (
        <CashFlowContext.Provider value={value}>
            {children}
        </CashFlowContext.Provider>
    );
};
